import { Chat, ChatMessage, ChatMessageSend } from 'app/components/shared/Chat'
import { QuotationRequest } from 'EstraSuppliers'
import React, { useContext, useState } from 'react'
import { MapToChatMessage } from '../mappers'
import { v4 as uuidv4 } from 'uuid'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { sendQuotationChatMessage } from './utils'
import { formatApiIsoDate } from 'app/utils/date'

interface Props {
  quotationRequest: QuotationRequest
}

export const QuotationChat: React.FC<Props> = ({ quotationRequest }) => {
  const authCtx = useContext(AuthenticationContext)
  const authToken = authCtx?.authToken || ''
  const userName =
    authCtx && authCtx.actor
      ? authCtx.actor.supplier.company_name || authCtx.actor.supplier.name || ''
      : ''

  const initialChatMessages = quotationRequest.quotation_request_messages
    ? quotationRequest.quotation_request_messages.map(MapToChatMessage)
    : []

  const [messages, setMessages] = useState<ChatMessage[]>(initialChatMessages)

  const onSendMessage = (message: ChatMessageSend) => {
    // At this point no API call has been made, message is added to the state with no data from the server
    // The api call is passed as promise on sendMessage prop, this is going to be executed in the Message component,
    // when completed it will update the Message component internal state, this way i don't need to update the list, avoiding concurrency problems
    const messageId = uuidv4()
    const updatedMessages = messages.concat({
      id: messageId,
      sendMessage: () =>
        sendQuotationChatMessage(
          authToken,
          quotationRequest.id,
          message,
          authCtx?.updateAuthToken
        ),
      data: {
        username: userName,
        isYou: true,
        message: message.message,
        type: message.type,
        display_sent_at: formatApiIsoDate(message.sent_at, true, true, ' '),
        sent_at: message.sent_at,
      },
    })

    setMessages(updatedMessages)
  }

  return (
    <Chat
      messages={messages}
      onSendMessage={onSendMessage}
      maxHeight={'400px'}
    ></Chat>
  )
}
